<template>
  <div
    v-clickoutside="handleCloseChoose"
    class="choose-type"
    @click="handleToggleChoose"
  >
    <div class="receive-tit">
      <template v-if="activeName">
        {{ activeName }}
      </template>
      <span v-else>{{ $t('message["878"]') }}</span>
      <i
        class="iconfont fs-blue"
        :class="{'iconicon-test18': !showChooseList, 'iconicon-test14': showChooseList}"
      />
    </div>
    <!-- 切换列表类型 -->
    <transition name="slide-up">
      <div
        v-show="showChooseList"
        ref="chooseList"
        class="choose-list"
      >
        <cell-list
          v-if="options.length"
          :data="options"
          @change="handleChangeChoose"
        >
          <template
            v-slot:item="{ data }"
          >
            <div
              class="item"
              :class="{ 'checked': data.checked }"
            >
              <span class="name"><em :title="data.truename">{{ data.truename }}</em> {{ !$isDingDing ? data.mobile : '' }}</span>
              <span class="right">
                <i
                  v-if="data.checked"
                  class="iconfont iconicon-test16 fs-blue"
                />
              </span>
            </div>
          </template>
        </cell-list>
        <div
          v-else
          class="no-list-data"
        >
          {{ $t('message["1553"]') }}<a-button
            class="back-btn"
            @click="handleCloseChoose"
          >
            {{ $t('message["282"]') }}
          </a-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CellList from '@/components/mobile/CellList'
import { clickoutside } from '@/lib/directives'
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  directives: { clickoutside },
  components: {
    CellList
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showChooseList: false, // 选择框是否展示
      activeKey: this.value || 'add',
      activeName: '',
      activeMobile: ''
    }
  },
  computed: {
    ...mapState('organization/org', ['orgSelectDatas']),
    options () {
      let arr2 = cloneDeep(this.orgSelectDatas)
      arr2 = arr2.map(ele => {
        if (ele.mobile) {
          let str = ele.mobile
          ele.mobile = str.substring(0, 3) + '****' + str.substring(7, 11)
        }
        return ele
      })
      return arr2
    }
  },
  created () {
  },
  methods: {
    handleToggleChoose (e) {
      if (this.$refs.chooseList.contains(e.target)) return
      this.showChooseList = !this.showChooseList
    },
    handleCloseChoose (e) {
      this.showChooseList = false
    },
    handleChangeChoose (item, index) {
      this.options.forEach((item, index) => {
        this.$set(item, 'checked', false)
      })
      this.$set(item, 'checked', true)
      this.activeKey = item.userid
      this.activeName = item.truename
      item.newMobile = this.orgSelectDatas[index].mobile ? this.orgSelectDatas[index].mobile : ''
      this.showChooseList = false
      this.$emit('getActive', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.receive-tit {
  position: relative;
  i{
    position: absolute;
    right: 0;
    color: #ccc
  }
  span {
    color: #999;
  }
}
.choose-list {
  position: fixed;
  top: 12px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 100;
  .name {
    em {
      display: inline-block;
      min-width: 80px;
      margin-right: 10px;
      font-style: normal;
      height: 41px;
      line-height: 41px;
      vertical-align: middle;
    }
  }
  .item.checked {
    .name {
      color: $primary-color;
    }
  }
  .cell-list {
    height: calc(100vh - 70px);
  }
}
.slide-up-enter,
.slide-up-leave-active {
  -webkit-transform: translate3d(0, -200%, 0);
  transform: translate3d(0, -200%, 0);
}

.slide-up-enter-active,
.slide-up-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.no-list-data {
  text-align:center;
  margin: 100px auto;
  .back-btn {
    margin-left: 16px;
  }
}
</style>
